import React from 'react';
import { formatGameDate, formatGameTime } from '../utils/dateFormatter';
import './GraphicTryoutPhotoFrame2.css';
import api from '../services/api';

const API_BASE_URL = api.defaults.baseURL.replace('/api', '');

function GraphicTryoutPhotoFrame2({
  graphicData,
  teamColors,
  backgroundStyle = 'linear-gradient',
  homeTeamLogo,
  backgroundPhotoPreview,
  showWatermark = true,
  teamSport,
  layoutSettings = {
    logoPosition: 'bottom-left',
    infoPosition: 'right',
    yearPosition: 'top-left',
    tryoutsOpacity: 1,
    textTreatment: 'shadow',
  },
  dateFormat = 'full',
}) {
  const {
    homeTeam,
    ageGroup,
    tryoutDate,
    tryoutTime,
    location,
    contact,
    additionalInfo,
  } = graphicData;

  const getLogoSrc = (logoUrl) => {
    if (!logoUrl) return null;
    if (logoUrl.startsWith('data:')) return logoUrl;
    if (logoUrl.startsWith('http')) return logoUrl;
    if (logoUrl.startsWith('/uploads')) return `${API_BASE_URL}${logoUrl}`;
    return logoUrl;
  };

  // Generate background based on style
  const getBackgroundStyle = () => {
    switch (backgroundStyle) {
      case 'linear-gradient':
        return `linear-gradient(135deg, ${teamColors.primary} 0%, ${teamColors.secondary} 100%)`;
      case 'radial-gradient':
        return `radial-gradient(circle at center, ${teamColors.primary} 0%, ${teamColors.secondary} 100%)`;
      case 'diagonal-gradient':
        return `linear-gradient(45deg, ${teamColors.primary} 0%, ${teamColors.secondary} 100%)`;
      case 'split-two-tone':
        return `linear-gradient(90deg, ${teamColors.primary} 0%, ${teamColors.primary} 50%, ${teamColors.secondary} 50%, ${teamColors.secondary} 100%)`;
      case 'solid-primary':
        return teamColors.primary;
      case 'solid-secondary':
        return teamColors.secondary;
      default:
        return `linear-gradient(135deg, ${teamColors.primary} 0%, ${teamColors.secondary} 100%)`;
    }
  };

  return (
    <div
      className="graphic-tryout-photo-frame2"
      id="graphic-tryout"
      style={{ background: getBackgroundStyle() }}
    >
      {/* Background Photo with Overlay */}
      <div className="tryout-photo-background2">
        {backgroundPhotoPreview ? (
          <img src={backgroundPhotoPreview} alt="" className="tryout-bg-img2" />
        ) : (
          <div
            className="tryout-photo-placeholder2"
            style={{ background: getBackgroundStyle() }}
          >
            <div className="placeholder-icon">📸</div>
            <div className="placeholder-text">Upload team or field photo</div>
          </div>
        )}
        <div className="tryout-photo-overlay2"></div>
      </div>

      {/* Center - TRYOUTS Title (always centered) */}
      <div className="tryout-hero-section2">
        <div
          className="tryout-title2"
          style={{ opacity: layoutSettings.tryoutsOpacity }}
        >
          TRYOUTS
        </div>
      </div>

      {/* Year - Dynamic Position */}
      <div className={`tryout-year2 position-${layoutSettings.yearPosition}`}>
        2026
      </div>

      {/* Logo - Dynamic Position */}
      {homeTeamLogo ? (
        <div
          className={`tryout-team-logo2 position-${layoutSettings.logoPosition}`}
        >
          <img src={getLogoSrc(homeTeamLogo)} alt="" />
        </div>
      ) : (
        <div
          className={`tryout-team-logo2 position-${layoutSettings.logoPosition}`}
        >
          <div className="logo-emoji">
            {teamSport === 'Softball' ? '🥎' : '⚾'}
          </div>
        </div>
      )}

      {/* Info Panel - Dynamic Position */}
      <div
        className={`tryout-info-panel2 position-${layoutSettings.infoPosition} text-treatment-${layoutSettings.textTreatment}`}
      >
        <div className="tryout-info-header2">{homeTeam || 'YOUR TEAM'}</div>

        <div className="tryout-details2">
          {ageGroup && <div className="tryout-detail-item2">🎯 {ageGroup}</div>}
          {tryoutDate && (
            <div className="tryout-detail-item2">
              📅 {formatGameDate(tryoutDate, dateFormat)}
            </div>
          )}
          {tryoutTime && (
            <div className="tryout-detail-item2">
              🕐 {formatGameTime(tryoutTime)}
            </div>
          )}
          {location && <div className="tryout-detail-item2">📍 {location}</div>}
        </div>

        {additionalInfo && (
          <div className="tryout-description2">{additionalInfo}</div>
        )}

        {contact && <div className="tryout-registration2">{contact}</div>}
      </div>

      {showWatermark && (
        <div className="playmaker-watermark">
          <img src="/PMlogoleft.png" alt="" />
        </div>
      )}
    </div>
  );
}

export default GraphicTryoutPhotoFrame2;
